(function () {
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(
        cents,
        window.theme && window.theme.moneyFormat
      );
    }
    return "$" + (cents / 100).toFixed(2);
  }

  function initUpsell(section) {
    if (!section || section.dataset.upsellInit === "true") return;
    section.dataset.upsellInit = "true";

    // Hard cap on how many cards are ever visible / counted, no matter how
    // many <li> cards the HTML renders.
    var MAX_VISIBLE = 4;

    var grid = section.querySelector(".upsell__grid");
    var cards = section.querySelectorAll(".upsell-card");
    var itemCountEl = section.querySelector("[data-item-count]");
    var totalEl = section.querySelector("[data-total-display]");
    var compareTotalEl = section.querySelector("[data-compare-total-display]");
    var saveEl = section.querySelector("[data-save-display]");
    var ctaBtn = section.querySelector("[data-upsell-add]");
    var ctaText = section.querySelector("[data-cta-text]");

    // Snapshot the original DOM order so we can restore it after a sort.
    var originalOrder = Array.from(cards);

    // Parse tag map
    var tagMapEl = document.getElementById("upsell-tag-map");
    var tagMap = {};
    if (tagMapEl) {
      try {
        tagMap = JSON.parse(tagMapEl.textContent);
      } catch (e) {}
    }

    var lastProcessedVariantId = null;

    // Parse variant tags map from embedded JSON
    var variantTagsMap = {};
    var variantTagsEl = document.getElementById("upsell-variant-tags");
    if (variantTagsEl) {
      try {
        variantTagsMap = JSON.parse(variantTagsEl.textContent);
      } catch (e) {}
    }

    // --- Visibility helpers: JS is the single source of truth for "max 4" ---

    function getCardsInDomOrder() {
      if (grid) return Array.from(grid.querySelectorAll(".upsell-card"));
      return Array.from(cards);
    }

    // Show only the first MAX_VISIBLE cards in current DOM order; hide the rest.
    function applyVisibilityLimit() {
      getCardsInDomOrder().forEach(function (card, idx) {
        card.classList.toggle("upsell-card--hidden", idx >= MAX_VISIBLE);
      });
    }

    function restoreOriginalOrder() {
      if (!grid) return;
      originalOrder.forEach(function (card) {
        grid.appendChild(card);
      });
    }

    // --- Variant detection ---

    function getVariantFromUrl() {
      var params = new URLSearchParams(window.location.search);
      return params.get("variant");
    }

    function getMatchTagForVariant(variantId, variantTitle) {
      var matchTag = variantTagsMap[variantId] || "";
      if (matchTag) return matchTag;

      if (!variantTitle) return "";

      var colorName = variantTitle.split("/")[0].trim().toLowerCase();
      var variantSelect = document.querySelector('[name="id"]');
      if (!variantSelect) return "";

      var options = variantSelect.querySelectorAll("option");
      for (var i = 0; i < options.length; i++) {
        var option = options[i];
        var optionColor = option.textContent
          .trim()
          .split("/")[0]
          .trim()
          .toLowerCase();
        if (optionColor === colorName && variantTagsMap[option.value]) {
          matchTag = variantTagsMap[option.value];
          break;
        }
      }
      return matchTag;
    }

    function getVariantTitleFromDom(variantId) {
      var variantSelect = document.querySelector('[name="id"]');
      if (!variantSelect) return "";
      var option = variantSelect.querySelector(
        'option[value="' + variantId + '"]'
      );
      return option ? option.textContent.trim() : "";
    }

    function handleVariantChange(variantId, variantTitle) {
      if (!variantId || variantId === lastProcessedVariantId) return;
      lastProcessedVariantId = variantId;

      var title = variantTitle || getVariantTitleFromDom(variantId);
      var matchTag = getMatchTagForVariant(variantId, title);

      if (matchTag) {
        onMainVariantChange(matchTag);
      } else {
        // No tag -> back to default order, still capped at MAX_VISIBLE.
        onMainVariantChange("");
      }
    }

    window.addEventListener("popstate", function () {
      handleVariantChange(getVariantFromUrl());
    });

    // Poll for URL changes (handles direct variant clicks). Stored so it can
    // be cleared on section unload to avoid leaking timers in the editor.
    section._upsellInterval = setInterval(function () {
      var variantId = getVariantFromUrl();
      if (variantId && variantId !== lastProcessedVariantId) {
        handleVariantChange(variantId);
      }
    }, 500);

    document.addEventListener("variant:change", function (e) {
      if (e.detail && e.detail.variant) {
        var v = e.detail.variant;
        handleVariantChange(v.id.toString(), v.title);
      }
    });

    document.addEventListener("product:variant-change", function (e) {
      if (e.detail && e.detail.variant) {
        var v = e.detail.variant;
        handleVariantChange(v.id.toString(), v.title);
      }
    });

    function onMainVariantChange(matchTag) {
      if (!matchTag) {
        // Reset: original order, then re-apply the 4-visible cap.
        restoreOriginalOrder();
        applyVisibilityLimit();
        updateTotal();
        return;
      }

      var fullTag = "match:" + matchTag;
      var cardsArray = Array.from(cards);

      // Sort: cards carrying the match tag come first.
      cardsArray.sort(function (cardA, cardB) {
        var tagsA = tagMap[cardA.dataset.productId] || [];
        var tagsB = tagMap[cardB.dataset.productId] || [];
        var hasTagA = tagsA.indexOf(fullTag) !== -1 ? 1 : 0;
        var hasTagB = tagsB.indexOf(fullTag) !== -1 ? 1 : 0;
        return hasTagB - hasTagA;
      });

      if (grid) {
        cardsArray.forEach(function (card) {
          grid.appendChild(card);
        });
      }

      applyVisibilityLimit();
      updateTotal();
    }

    function updateCardFromSelect(card) {
      var select = card.querySelector("[data-variant-select]");
      if (!select) return;

      var opt = select.options[select.selectedIndex];
      if (!opt) return;

      card.dataset.variantId = opt.value;
      card.dataset.price = opt.dataset.price;
      card.dataset.comparePrice = opt.dataset.comparePrice || 0;
      card.dataset.available = opt.dataset.available;

      var priceEl = card.querySelector("[data-price-display]");
      var compareEl = card.querySelector("[data-compare-display]");

      if (priceEl)
        priceEl.textContent = formatMoney(parseInt(opt.dataset.price, 10));

      if (compareEl) {
        var comparePrice = parseInt(opt.dataset.comparePrice, 10) || 0;
        var price = parseInt(opt.dataset.price, 10) || 0;
        if (comparePrice > price) {
          compareEl.textContent = formatMoney(comparePrice);
          compareEl.style.display = "";
        } else {
          compareEl.style.display = "none";
        }
      }
    }

    function updateTotal() {
      var subtotal = 0;
      var compareSubtotal = 0;
      var count = 0;

      // Total = plain sum of selected items (no discount).
      // compareSubtotal = sum of compare-at prices (falls back to the price
      // when a product has no compare-at) -> used for strikethrough + savings.
      cards.forEach(function (card) {
        var isVisible = !card.classList.contains("upsell-card--hidden");
        var isAvailable = card.dataset.available === "true";

        var checkbox = card.querySelector(".upsell-card__checkbox");
        if (!checkbox) return;

        if (
          isVisible &&
          isAvailable &&
          checkbox.classList.contains("is-checked")
        ) {
          var price = parseInt(card.dataset.price, 10) || 0;
          var compare = parseInt(card.dataset.comparePrice, 10) || 0;
          subtotal += price;
          compareSubtotal += compare > price ? compare : price;
          count++;
        }
      });

      if (itemCountEl) itemCountEl.textContent = count;
      if (totalEl) totalEl.textContent = formatMoney(subtotal);

      // Show strikethrough compare-at total and savings only when the
      // compare-at total is actually higher than what they pay.
      var savings = compareSubtotal - subtotal;
      if (compareTotalEl && saveEl) {
        if (savings > 0 && count > 0) {
          compareTotalEl.textContent = formatMoney(compareSubtotal);
          compareTotalEl.style.display = "";
          saveEl.textContent = "You save " + formatMoney(savings);
          saveEl.style.display = "";
        } else {
          compareTotalEl.style.display = "none";
          saveEl.style.display = "none";
        }
      }

      if (ctaBtn) ctaBtn.disabled = count === 0;
      if (ctaText)
        ctaText.textContent =
          count === 0 ? "Select items to add" : "Add " + count + " to cart";
    }

    // Checkbox toggle and variant select wiring
    cards.forEach(function (card) {
      var checkbox = card.querySelector(".upsell-card__checkbox");
      if (!checkbox) return;

      checkbox.addEventListener("click", function () {
        if (card.dataset.available !== "true") return;
        var isChecked = checkbox.classList.toggle("is-checked");
        checkbox.setAttribute("aria-pressed", isChecked ? "true" : "false");
        card.classList.toggle("is-unchecked", !isChecked);
        updateTotal();
      });

      var select = card.querySelector("[data-variant-select]");
      if (select) {
        select.addEventListener("change", function () {
          updateCardFromSelect(card);
          updateTotal();
        });
      }

      if (card.dataset.available !== "true") {
        checkbox.classList.remove("is-checked");
        checkbox.setAttribute("aria-pressed", "false");
        card.classList.add("is-unchecked");
      } else if (!checkbox.classList.contains("is-checked")) {
        card.classList.add("is-unchecked");
      }
    });

    // --- Cart drawer opener (theme-dependent; never navigates to /cart) ---
    function openCartDrawerSafe() {
      // 1. Theme exposes an explicit global.
      if (typeof window.openCartDrawer === "function") {
        window.openCartDrawer();
        return;
      }
      // 2. Dawn-style <cart-drawer> custom element.
      var drawerEl = document.querySelector("cart-drawer");
      if (drawerEl && typeof drawerEl.open === "function") {
        drawerEl.classList.remove("is-empty");
        drawerEl.open();
        return;
      }
      // 3. Events various themes listen for to open/refresh the drawer.
      document.dispatchEvent(new CustomEvent("cart:open"));
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("drawerOpen"));
      // Intentionally no window.location redirect — we only open the drawer.
    }

    // Add to cart
    ctaBtn.addEventListener("click", function () {
      var items = [];
      cards.forEach(function (card) {
        var isVisible = !card.classList.contains("upsell-card--hidden");
        var checkbox = card.querySelector(".upsell-card__checkbox");
        if (!checkbox) return;
        if (
          isVisible &&
          checkbox.classList.contains("is-checked") &&
          card.dataset.available === "true"
        ) {
          items.push({
            id: parseInt(card.dataset.variantId, 10),
            quantity: 1,
            properties: { _upsell_source: "product-page-bundle" },
          });
        }
      });

      if (items.length === 0) return;

      ctaBtn.classList.add("is-loading");
      ctaText.textContent = "Adding...";

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Cart add failed");
          return response.json();
        })
        .then(function (data) {
          document.dispatchEvent(
            new CustomEvent("upsell:added", {
              detail: { items: data.items || [], count: items.length },
            })
          );

          openCartDrawerSafe();

          ctaText.textContent = "Added!";
          setTimeout(function () {
            ctaBtn.classList.remove("is-loading");
            updateTotal();
          }, 1000);
        })
        .catch(function (err) {
          console.error("[upsell] Add to cart failed", err);
          ctaText.textContent = "Try again";
          ctaBtn.classList.remove("is-loading");
        });
    });

    // Enforce the 4-visible cap on first load, before counting anything.
    applyVisibilityLimit();
    updateTotal();
  }

  function initAll() {
    document.querySelectorAll(".upsell").forEach(initUpsell);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Theme editor support
  document.addEventListener("shopify:section:load", initAll);

  // Clear the polling timer when a section is removed/re-rendered in the editor.
  document.addEventListener("shopify:section:unload", function (e) {
    var sec =
      (e.target && e.target.querySelector
        ? e.target.querySelector(".upsell")
        : null) || e.target;
    if (sec && sec._upsellInterval) {
      clearInterval(sec._upsellInterval);
      sec._upsellInterval = null;
    }
  });

  // AJAX color-swap support: clear timers before the old DOM is replaced,
  // then re-init the freshly inserted .upsell node.
  document.addEventListener("colorswap:unload", function () {
    document.querySelectorAll(".upsell").forEach(function (sec) {
      if (sec._upsellInterval) {
        clearInterval(sec._upsellInterval);
        sec._upsellInterval = null;
      }
    });
  });
  document.addEventListener("colorswap:load", initAll);
})();
